import React from "react";
import { Editor } from "slate";
import { Plugin } from "slate-react";
import { MARKS } from "../html";
import { AddHotkey } from "./hotkey";
import { AddIsToggledQuery } from "./isToggled";
import { AddToggleCommand } from "./toggleCommand";

const { type } = MARKS.ITALIC;

const isItalic = (editor: Editor) => editor.value.marks.some(x => x.type === type);

const toggleItalic = (editor: Editor) => editor.toggleMark(type);

/**
 * Slate plugin for italic formatting
 */
export const Italic: Plugin[] = [
  AddIsToggledQuery(type, isItalic),
  AddToggleCommand(type, toggleItalic),
  AddHotkey({ key: "i", action: toggleItalic }),
  {
    renderMark: (props, controller, next) => {
      const { mark, attributes } = props;
      if (mark.type === type) {
        return <em {...attributes}>{props.children}</em>;
      }
      else {
        return next();
      }
    },
  },
];
